function debounce(fn, wait = 500) {
    let timer;
    return event => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(fn, wait, event);
    };
}

function escapeHtml(htmlStr) {
    return htmlStr
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");        

}

export {
    debounce,
    escapeHtml
};
